import { render, staticRenderFns } from "./NewHearing.vue?vue&type=template&id=6d79fb8c&scoped=true"
import script from "./NewHearing.vue?vue&type=script&lang=js"
export * from "./NewHearing.vue?vue&type=script&lang=js"
import style0 from "./NewHearing.vue?vue&type=style&index=0&id=6d79fb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d79fb8c",
  null
  
)

export default component.exports